import { JOIN_HINTS_KEY, PENDING_REFERRAL_CODE_KEY } from './localStore';
import { PENDING_DEEP_LINK_KEY } from './deepLinks';
import { clearActivityLogQueue } from './logger';

const APP_STORE_KEY = 'app:v1';

/** Remove personal data stored on this device (GDPR Art. 17 — local leg). */
export function clearLocalPersonalData(): void {
  if (typeof window === 'undefined') return;

  try {
    localStorage.removeItem(APP_STORE_KEY);
    clearActivityLogQueue();

    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith('chat:')) {
        keysToRemove.push(key);
      }
    }
    for (const key of keysToRemove) {
      localStorage.removeItem(key);
    }

    sessionStorage.removeItem(JOIN_HINTS_KEY);
    sessionStorage.removeItem(PENDING_REFERRAL_CODE_KEY);
    sessionStorage.removeItem(PENDING_DEEP_LINK_KEY);
  } catch {
    // best-effort
  }
}
